import React from 'react'
import { CharacterCardProps } from './interface'

export function withCharacterCard(Component: React.FC<CharacterCardProps>) {
  function WithCharacterCard(props: CharacterCardProps) {
    return <Component {...props} />
  }
  return WithCharacterCard
}
